/* Poser son mot de passe.
 *
 * Deux portes mènent ici, et une seule fois chacune : l'invitation que la
 * direction envoie pour ouvrir un compte, et le lien de réinitialisation. Dans
 * les deux cas la session existe déjà — le lien l'a ouverte — il ne reste qu'à
 * choisir le mot de passe qui servira ensuite. */

import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { Capsule } from "@/ui/primitives";

const MINIMUM = 10;

export function MotDePasse({
  invitation,
  onFait,
}: {
  /** Première ouverture de compte, par opposition à un mot de passe oublié. */
  invitation: boolean;
  onFait: () => void;
}) {
  const [mdp, setMdp] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [erreur, setErreur] = useState<string | null>(null);
  const [envoi, setEnvoi] = useState(false);

  async function soumettre(e: React.FormEvent) {
    e.preventDefault();
    if (mdp.length < MINIMUM) {
      setErreur(`Le mot de passe fait au moins ${MINIMUM} caractères.`);
      return;
    }
    if (mdp !== confirmation) {
      setErreur("Les deux saisies ne correspondent pas.");
      return;
    }
    setErreur(null);
    setEnvoi(true);
    /* Le drapeau est ce qui referme cet écran, et le fragment de l'adresse ne
       survit pas à un rechargement : sans lui, un compte invité qui recharge
       la page entrerait sans mot de passe, et ne pourrait plus jamais revenir. */
    const { error } = await supabase.auth.updateUser({
      password: mdp,
      data: { mdp_pose: true },
    });
    setEnvoi(false);
    if (error) {
      setErreur(error.message);
      return;
    }
    onFait();
  }

  return (
    <div className="auth">
      <form className="auth-carte" onSubmit={soumettre}>
        <div className="auth-bandeau">
          <Capsule taille={22} inverse />
        </div>
        <h1 className="auth-titre">
          {invitation ? "Choisissez votre mot de passe" : "Nouveau mot de passe"}
        </h1>

        <div className="champ">
          <label htmlFor="mdp1">Mot de passe</label>
          <input
            id="mdp1"
            type="password"
            autoComplete="new-password"
            required
            autoFocus
            value={mdp}
            onChange={(e) => {
              setMdp(e.target.value);
              setErreur(null);
            }}
          />
        </div>
        <div className="champ">
          <label htmlFor="mdp2">Confirmation</label>
          <input
            id="mdp2"
            type="password"
            autoComplete="new-password"
            required
            value={confirmation}
            onChange={(e) => {
              setConfirmation(e.target.value);
              setErreur(null);
            }}
          />
        </div>

        {erreur ? <div className="auth-erreur">{erreur}</div> : null}

        <button className="btn btn-primary auth-entrer" type="submit" disabled={envoi}>
          {envoi ? "Enregistrement…" : "Enregistrer"}
        </button>

        <div className="auth-note">
          {MINIMUM} caractères au minimum. C'est avec lui que vous entrerez ensuite.
        </div>
      </form>
    </div>
  );
}
